import {
  aRuleTuningExpression,
  mockRuleTuningExpressionQueryOperationQuery,
  RuleTuningExpression,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const getMockRuleTuningExpressionQueryOperationQuery_edit = (
  tuningExpression: Partial<RuleTuningExpression>
) => ({
  __typename: 'Query',
  ruleTuningExpression: aRuleTuningExpression({
    id: '0',
    ...tuningExpression,
  }),
});

export const handlers = [
  mockRuleTuningExpressionQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          ruleTuningExpression: aRuleTuningExpression(),
        },
      });
    }
  ),
];
